import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import zhCN from './locales/zh-CN.json'
import enUS from './locales/en-US.json'
import jaJP from './locales/ja-JP.json'
import koKR from './locales/ko-KR.json'

const resources = {
  'zh-CN': {
    translation: zhCN,
  },
  'en-US': {
    translation: enUS,
  },
  'ja-JP': {
    translation: jaJP,
  },
  'ko-KR': {
    translation: koKR,
  },
}

// 从localStorage获取保存的语言，默认英文
const savedLanguage = localStorage.getItem('aether-language') || 'en-US'

i18n.use(initReactI18next).init({
  resources,
  lng: savedLanguage,
  fallbackLng: 'en-US',
  interpolation: {
    escapeValue: false,
  },
})

document.documentElement.lang = savedLanguage

// 监听语言变化，保存到localStorage
i18n.on('languageChanged', (lng) => {
  localStorage.setItem('aether-language', lng)
  document.documentElement.lang = lng
})

export default i18n
